import type { DocumentSetDateField } from "./document-selection.model";
import type {
  ContractDocumentType,
  DocumentSet,
  RecognitionPathContractDocumentType,
  TypedSetDocumentType,
} from "./document-set-settings";

export type CombinedDocumentContractType = ContractDocumentType | RecognitionPathContractDocumentType;

interface DocumentSetSyncConfig<K extends TypedSetDocumentType> {
  sets: [DocumentSet<K>, ...DocumentSet<K>[]];
  fields: [DocumentSetDateField, ...DocumentSetDateField[]];
}

type DocumentTypeSynchronizedSetFieldMap = {
  [K in CombinedDocumentContractType]: DocumentSetSyncConfig<K>[];
};

function getContractConfig<T extends ContractDocumentType>(): DocumentSetSyncConfig<T>[] {
  return [
    {
      sets: ["SignedByAllParties", "SignedByOneParty", "Unsigned"],
      fields: ["issueDate", "validFrom", "validUntil"],
    },
  ];
}

function getRecognitionPathContractConfig<T extends RecognitionPathContractDocumentType>(): DocumentSetSyncConfig<T>[] {
  return [
    {
      sets: [
        "SignedByAllPartiesCurrentRecognitionPath",
        "SignedByOnePartyCurrentRecognitionPath",
        "UnsignedCurrentRecognitionPath",
      ],
      fields: ["issueDate", "validFrom", "validUntil"],
    },
    {
      sets: [
        "SignedByAllPartiesAlternativeRecognitionPath",
        "SignedByOnePartyAlternativeRecognitionPath",
        "UnsignedAlternativeRecognitionPath",
      ],
      fields: ["issueDate", "validFrom", "validUntil"],
    },
  ];
}

export const DocumentTypeSynchronizedSetFields: DocumentTypeSynchronizedSetFieldMap = {
  AGREEMENTSPONSORSHIP: getContractConfig(),
  CONTRACTWORK: getContractConfig(),
  AGGREEACC81A: getContractConfig(),
  TRAININGCONTRACT: getContractConfig(),
  CANCELLATIONEMPLOYMENTCONTRACT: getContractConfig(),
  TERMINATIONAGREEMENT: getContractConfig(),
  CANCELLATIONTRAININGCONTRACT: getContractConfig(),
  FIRSTCONTRACTEXTENSIONPRE: getContractConfig(),
  SECONDCONTRACTEXTENSIONPRE: getContractConfig(),
  FIRSTCONTRACTEXTENSIONAFTER: getContractConfig(),
  SECONDCONTRACTEXTENSIONAFTER: getContractConfig(),
  CONFIRMATIONNOMATCHING: getContractConfig(),
  POACHILDREN81A: getRecognitionPathContractConfig(),
  POAPARTNER81A: getRecognitionPathContractConfig(),
  POACANDIDATE: getRecognitionPathContractConfig(),
  POAMAIN81A: getRecognitionPathContractConfig(),
  POASUB81A: getRecognitionPathContractConfig(),
  AUTHACCEPTAGENCY: getRecognitionPathContractConfig(),
  POWEROFATTORNEYRELOCATION: getRecognitionPathContractConfig(),
  GENERALPOA: getRecognitionPathContractConfig(),
  POAFAMILIY81A: getRecognitionPathContractConfig(),
  POWEROFATORNEYWORKRECOGNITION: getRecognitionPathContractConfig(),
  POWEROFATTORNEYVALUATION: getRecognitionPathContractConfig(),
  POAEMPLOYEEQUALIFICATION: getContractConfig(),
  PARTICIPANTCONTRACT: getContractConfig(),
  INITIALCONTRACT: getContractConfig(),
  LIABILITYINSURANCE: getContractConfig(),
  INCOMINGINSURANCE: getContractConfig(),
  BUNDLEINSURANCE: getContractConfig(),
} as const;
